import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_sidebar-layout/feed/$feedId/")({
  beforeLoad: ({ search, params }) => {
    throw redirect({ to: "/app/feed/$feedId/view", params, search });
  },
});
